<template>
  <div>
    <div v-if="anyUserOrganizationAvailable">
      <v-row
        class="mt-2"
        :style="{ display: companyVisibility }"
      >
        <v-col
          cols="10"
          class="pb-0 pr-0"
        >
          <v-select
            v-model="selectedProject"
            light
            color="#37474F"
            flat
            dense
            :items="organizationProjects"
            item-text="name"
            item-value="id"
            label="All Projects"
            outlined
            background-color="transparent"
            class="small-select"
            @change="getAttendenceByProject"
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex"
        >
          <v-btn
            dark
            fab
            outlined
            icon
            color="#37474F"
            small
            @click="getAllAttendenceList()"
          >
            <v-icon
              small
              dark
            >
              mdi-filter-off
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div class="d-flex">
        <div
          v-if="!workerCheck"
          class="from-style"
        >
          <v-dialog
            ref="fromDialog"
            v-model="fromCalendar"
            :return-value.sync="fromDate"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <div class="chip-container">
                <v-chip
                  v-bind="attrs"
                  dark
                  rounded
                  color="#FFF"
                  small
                  elevation="0"
                  :class="appUserRole === 'contractor' ? 'mt-3' : 'mt-0'"
                  v-on="on"
                  @click="showFilterForm = true"
                >
                  <v-icon
                    small
                    dark
                  >
                    mdi-filter
                  </v-icon>
                  &nbsp; {{ fromDate }}
                </v-chip>
              </div>
            </template>
            <v-date-picker
              v-if="fromCalendar"
              v-model="fromDate"
              full-width
              color="#37474F"
              light
              :max="maxStartDate"
              @input="$refs.fromDialog.save(fromDate)"
              @change="getAttendenceByDate"
            >
              <v-spacer />
              <v-btn
                text
                color="#37474F"
                @click="fromCalendar = false"
              >
                Cancel
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </div>
      </div>
      <div v-if="!workerCheck">
        <div
          v-if="anyUserAttendenceAvailable"
          class="listing-attendence"
        >
          <div>
            <v-card
              v-for="(item, index) in appUserAttendence"
              :key="index"
              color="#F8F8F8"
              dark
              class="card-style"
              elevation="0"
              @click="attendenceRecords(item.external_id)"
            >
              <v-card-text>
                <p
                  class="title-text-style d-flex justify-space-between align-center"
                >
                  <font class="subheader-style">
                    {{ item.first_name }} {{ item.last_name }}
                  </font>
                  <span class="d-flex flex-column align-end attendance-time">
                    <!-- IN -->
                    <span class="d-flex align-center in-time">
                      <span
                        class="px-2 mdi mdi-arrow-top-right attendance-icon"
                      />
                      {{
                        formatTime(
                          item.checkin_record &&
                            item.checkin_record.checkin_time,
                        )
                      }}
                    </span>

                    <!-- OUT -->
                    <span
                      class="d-flex align-center out-time"
                      :class="{
                        disabled: !(
                          item.checkin_record &&
                          item.checkin_record.checkout_time
                        ),
                      }"
                    >
                      <span
                        class="px-2 mdi mdi-arrow-bottom-left attendance-icon"
                      />
                      {{
                        formatTime(
                          item.checkin_record &&
                            item.checkin_record.checkout_time,
                        )
                      }}
                    </span>
                  </span>
                </p>

                <p class="title-text-style">
                  Project:
                  <font class="value-text-style">
                    {{ item.checkin_record.project.name }}
                  </font>
                </p>
                <p class="title-text-style">
                  Role:
                  <font class="value-text-style">
                    {{ item.app_user_role | arrangeRole }}
                  </font>
                </p>
                <!-- <p class="title-text-style">
                  Type:
                  <font class="value-text-style">
                    {{ item.checkin_record.type | arrangePretty }}
                  </font>
                </p> -->
                <!-- <p>
                  <font
                    v-if="item.checkin_record.total_hours === null"
                    class="chip-style active-color"
                  >
                    Onsite*
                  </font>
                </p> -->
                <!-- <v-chip
                  v-if="item.checkin_record.total_hours !== null"
                  dark
                  rounded
                  outlined
                  color="#e6e6e6"
                  x-small
                  elevation="0"
                  class="chip-style"
                >
                  <v-icon x-small> mdi-account-clock </v-icon>&nbsp;
                  {{ item.checkin_record.total_hours }} Hrs
                </v-chip> -->
                <div
                  v-if="
                    item.checkin_record.checkout_time === null && isTodayFilter
                  "
                  class="d-flex justify-end"
                >
                  <v-btn
                    small
                    elevation="0"
                    color="#37474F"
                    @click.stop="showCheckoutDialog(item)"
                  >
                    Checkout
                  </v-btn>
                </div>
                <div
                  v-else-if="isTodayFilter"
                  class="d-flex justify-end"
                >
                  <v-btn
                    small
                    elevation="0"
                    color="#37474F"
                    @click.stop="showCheckinDialog(item)"
                  >
                    Checkin <v-icon>mdi mdi-menu-right</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
            <div
              ref="observer"
              class="observer"
            />
            <div class="text-center">
              <v-progress-circular
                v-if="lazyLoader"
                size="25"
                :width="1"
                color="#E2E2E2"
                indeterminate
              />
            </div>
          </div>
        </div>
        <div
          v-else
          class="empty-alert-div mt-5"
        >
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br>
            <br>
            <br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>No attendance found
            </p>
            <br>
            <br>
          </v-card>
        </div>
      </div>
      <div
        v-else
        class="empty-alert-div mt-5"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>You don't have permission to view this resource
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-5"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>No
          organization found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <app-user-attendence-records
      v-if="showAttendenceRecords"
      :attendence-id="attendenceId"
      :checkin-date="fromDate"
      @closed="showAttendenceRecords = false"
    />
    <checkout-pop-up
      v-if="showCheckoutPopup"
      :checkin-id="activeCheckinId"
      :checkin-time="checkinTime"
      @close="showCheckoutPopup = false"
    />
    <checkin-pop-up
      v-if="showCheckinPopup"
      :projects="organizationProjects"
      :user-id="selectedUser"
      :org-ext-id="selectedOrganization.organization.external_id"
      @close="showCheckinPopup = false"
    />
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import moment from 'moment';
import AppUserAttendenceRecords from './AppUserAttendenceRecords.vue';
import spinner from 'src/views/components/SpinnerCentre';
import CheckoutPopUp from './CheckoutPopUp.vue';
import CheckinPopUp from './CheckinPopUp.vue';
export default {
  name: 'OnSiteAttendence',
  components: {
    'app-user-attendence-records': AppUserAttendenceRecords,
    'centre-spinner': spinner,
    'checkout-pop-up': CheckoutPopUp,
    'checkin-pop-up': CheckinPopUp,
  },
  filters: {
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
    arrangeRole (val) {
      if (val === 'site-manager') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data: () => ({
    loading: false,
    fromCalendar: false,
    maxStartDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD'),
    orgExternalId: null,
    selectedUser: null,
    selectedProject: null,
    attendenceId: null,
    showAttendenceRecords: false,
    lazyLoader: false,
    startPage: 0,
    observer: null,
    appUserRole: '',
    currentOrg: null,
    workerCheck: false,
    activeCheckinId: null,
    showCheckoutPopup: false,
    showCheckinPopup: false,
    checkinTime: null,
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationAvailable () {
      if (this.userOrganizations.length === 0) {
        return false;
      }
      return true;
    },
    appUserAttendence () {
      return this.$store.getters['appusers/getOnSiteAppUsersAttendence'];
    },
    isTodayFilter () {
      return this.fromDate === moment().format('YYYY-MM-DD');
    },
    appUsersCompany () {
      return this.$store.getters['company/getAppUsersCompanies'];
    },
    anyUserAttendenceAvailable () {
      if (
        this.anyUserOrganizationAvailable &&
        this.appUserAttendence.length === 0
      ) {
        return false;
      }
      return true;
    },
    organizationProjects () {
      return this.$store.getters['projects/getOrganizationProjects'];
    },
    companyVisibility () {
      return this.appUserRole !== 'site-manager' ? 'none' : '';
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.$store.dispatch('appusers/clearOnSiteAppUsersAttendence');
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      await this.getUserOrganizations();
      this.loading = false;
    },
    showCheckoutDialog (item) {
      this.activeCheckinId = item.checkin_record.id;
      this.checkinTime = item.checkin_record.checkin_time;
      this.showCheckoutPopup = true;
    },

    formatTime (time) {
      return time ? moment(time).local().format('hh:mm A') : '--:-- --';
    },
    showCheckinDialog (item) {
      this.selectedUser = item.id;
      this.showCheckinPopup = true;
    },
    async getOrganizationProjects () {
      this.loading = true;
      await this.$store.dispatch('projects/fetchOrganizationProjects', {
        organizationExtId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchUserOrganizations', {
          params: {
            requestStatus: 'accepted',
          },
        })
        .then(() => {
          this.anyUserOrganizationAvailable && this.setOrganization();
        });
      this.loading = false;
    },
    async setOrganization () {
      if (this.anyUserOrganizationAvailable) {
        this.currentOrg = this.userOrganizations.filter((item) => {
          return (
            item.organization.external_id ===
            this.selectedOrganization.organization.external_id
          );
        });
        this.appUserRole = this.currentOrg[0].app_user_role;
        if (this.currentOrg[0].app_user_role === 'site-manager') {
          this.workerCheck = false;
          // await this.getAppUsersCompany();
          await this.getOrganizationProjects();
          await this.getAppUsersAttendence();
          await this.loadMore();
        }
        if (this.currentOrg[0].app_user_role === 'contractor') {
          this.workerCheck = true;
          // this.workerCheck = false;
          // this.selectedCompany = this.currentOrg[0].company.id;
          // await this.getAppUsersAttendence();
          // await this.loadMore();
        }
        if (this.currentOrg[0].app_user_role === 'worker') {
          this.workerCheck = true;
        }
      }
    },
    async getAppUsersCompany () {
      this.loading = true;
      await this.$store.dispatch('company/fetchAppUsersCompanies', {
        organizationId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async loadMore () {
      if (this.appUserAttendence.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.getAppUsersAttendence();
      }
    },
    async getAppUsersAttendence () {
      this.lazyLoader = true;
      const date = this.fromDate || moment().format('YYYY-MM-DD');
      const from = moment(`${date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      const to = moment(`${date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      await this.$store
        .dispatch('appusers/fetchOnSiteAppUsersAttendence', {
          params: {
            params: {
              from,
              to,
              startPage: this.startPage,
              companyId: null,
              projectId: this.selectedProject,
              limit: 50,
            },
          },
          organizationId: this.selectedOrganization.organization.external_id,
          type: 'on-site',
        })
        .then(() => {
          this.startPage += 50;
          this.lazyLoader = false;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // async getAttendenceByCompany (data) {
    //   this.loading = true;
    //   await this.$store
    //     .dispatch('appusers/clearOnSiteAppUsersAttendence')
    //     .then(() => {
    //       this.startPage = 0;
    //       this.selectedCompany = data;
    //     });
    //   await this.getAppUsersAttendence();
    //   await this.loadMore();
    //   this.loading = false;
    // },
    async getAttendenceByProject (data) {
      this.loading = true;
      await this.$store
        .dispatch('appusers/clearOnSiteAppUsersAttendence')
        .then(() => {
          this.startPage = 0;
          this.selectedProject = data;
        });
      await this.getAppUsersAttendence();
      await this.loadMore();
      this.loading = false;
    },
    async getAllAttendenceList () {
      this.loading = true;
      this.fromDate = moment().format('YYYY-MM-DD');
      this.selectedProject = null;
      this.startPage = 0;
      await this.$store.dispatch('appusers/clearOnSiteAppUsersAttendence');
      await this.getAppUsersAttendence();
      await this.loadMore();
      this.loading = false;
    },
    async getAttendenceByDate () {
      this.loading = true;
      this.startPage = 0;
      await this.$store.dispatch('appusers/clearOnSiteAppUsersAttendence');
      await this.getAppUsersAttendence();
      await this.loadMore();
      this.loading = false;
    },
    attendenceRecords (id) {
      this.attendenceId = id;
      this.showAttendenceRecords = true;
    },
  },
};
</script>

<style scoped>
.card-style {
  border-radius: 10px;
  margin-top: 20px;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.col-5 {
  padding: 12px;
  padding-right: 0;
}

.observer {
  height: 40px;
}

.empty-alert-msg {
  padding: 12px;
}

.next-button-style {
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.chip-style {
  position: absolute;
  top: 20px;
  right: 15px;
}

.v-card-text {
  padding: 12px !important;
}

.active-color {
  color: #2e7d32;
  font-weight: bold;
  font-size: 13px;
}
.onsite-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #63ca7f;
}
.offsite-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #c62828;
}
.attendance-icon {
  font-size: 14px;
  line-height: 1;
}
.attendance-time {
  font-size: 11px;
  line-height: 1.2;
  font-weight: 600;
}
/* Green IN arrow */
.in-time .attendance-icon {
  color: #2e7d32;
}

/* Red OUT arrow */
.out-time .attendance-icon {
  color: #c62828;
}

/* Disabled OUT */
.out-time.disabled .attendance-icon {
  color: #9e9e9e;
}
</style>
